import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  const before = ['Hours every week searching for drills', 'Running out of ideas mid-season', 'Inconsistent sessions with no clear plan', 'Unsure if players are developing correctly', 'Dreading practice because you feel underprepared', "Stressed about parent questions you can't answer"];
  const after = ['Entire season planned in a single afternoon', 'Never run out of drills or session ideas again', 'Every session is structured, purposeful, and progressive', 'Clear development pathway for every player, every age', 'Walk onto the pitch confident and organized', 'Handle parent questions with professionalism and clarity'];
  return <section className="bg-ink py-24 px-4 border-t border-white/5" data-id="element-226">
      <div className="max-w-5xl mx-auto" data-id="element-227">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-16 uppercase" data-id="element-228">
          What Your Coaching Life Looks Like{' '}
          <span className="text-brightGreen" data-id="element-229">With Soccer Ready™</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-230">
          {/* BEFORE */}
          <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-8" data-id="element-231">
            <h3 className="font-display text-2xl text-red-500 mb-6 uppercase tracking-wide text-center" data-id="element-232">
              Before Soccer Ready™
            </h3>
            <ul className="space-y-5" data-id="element-233">
              {before.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-234">
                  <XCircle className="w-5 h-5 text-red-500/70 shrink-0 mt-0.5" data-id="element-235" />
                  <span className="text-gray-300" data-id="element-236">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="bg-forest border border-brightGreen/30 rounded-2xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(76,222,128,0.1)]" data-id="element-237">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brightGreen/10 rounded-full blur-3xl" data-id="element-238"></div>
            <h3 className="font-display text-2xl text-brightGreen mb-6 uppercase tracking-wide text-center" data-id="element-239">
              After Soccer Ready™
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-240">
              {after.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-241">
                  <CheckCircle2 className="w-5 h-5 text-brightGreen shrink-0 mt-0.5" data-id="element-242" />
                  <span className="text-white font-medium" data-id="element-243">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}